import React, { useRef, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import "./GestionData.css";
import { FaCheckCircle } from "react-icons/fa";

interface GestionItem {
  titulo: string;
  descripcion: string;
}

interface AlcanceItem {
  titulo: string;
  descripcion?: string;
}

interface GestionDataProps {
  gestion: GestionItem[];
  alcance: AlcanceItem[];
}

export default function GestionData({ gestion, alcance }: GestionDataProps) {
  const { t } = useTranslation();
  const cajasRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [animadas, setAnimadas] = useState<number[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idx = Number((entry.target as HTMLElement).dataset.idx);
            setAnimadas((prev) => {
              if (!prev.includes(idx)) return [...prev, idx];
              return prev;
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 },
    );

    cajasRefs.current.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [alcance]);

  return (
    <>
      <div className="componente-data">
        <h3>{t("gestion.gestion_title")}</h3>
        <div className="contenedor-data">
          {Array.isArray(gestion) && gestion.map((item, idx) => (
            <div className="grupo-data" key={idx}>
              <div className="caja-data">{item.titulo}</div>
              <motion.p
                className="descripcion-data"
                initial={{ opacity: 0, y: -20 }}
                whileInView={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                viewport={{ once: false, amount: 0.3 }}
                transition={{ duration: 0.6 }}
              >
                {item.descripcion}
              </motion.p>
            </div>
          ))}
        </div>
      </div>

      <div className="componente-data2">
        <h3>{t("gestion.alcance_title")}</h3>
        <div className="contenedor-data2">
          {Array.isArray(alcance) && alcance.map((grupo, idx) => (
            <div className="grupo-data2" key={idx}>
              <div
                className="caja-data2 con-icono-data"
                ref={(el) => { cajasRefs.current[idx] = el; }}
                data-idx={idx}
                style={{
                  animation: animadas.includes(idx)
                    ? "bgMoveData 3s ease-in-out forwards"
                    : "none",
                } as React.CSSProperties}
              >
                <FaCheckCircle className="icono-data" />
                <span className="texto-item">{grupo.titulo}</span>
              </div>
              {grupo.descripcion && (
                <motion.p
                  className="descripcion-data2"
                  initial={{ opacity: 0, y: -20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  viewport={{ once: false, amount: 0.3 }}
                  transition={{ duration: 0.6 }}
                >
                  {grupo.descripcion}
                </motion.p>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
